import { Component, OnInit } from '@angular/core';
import {FieldComponentAbstract} from '../abstracts/FieldComponentAbstract';
import {MdButtonToggleChange} from '@angular/material';

@Component({
  selector: 'app-yes-no-field',
  templateUrl: './yes-no-field.component.html',
  styleUrls: ['./yes-no-field.component.scss']
})
export class YesNoFieldComponent extends FieldComponentAbstract {

  handleChange(event: MdButtonToggleChange) {
    this.fieldValue.yes_no_value = <boolean>event.value;
    this.onChange(this.fieldValue);
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/yes-no-field/yes-no-field.component.ts